import { FC } from 'react'
import { PanelLeftOpen } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'
import { cn } from '../../lib/utils'

interface SidebarRailProps {
  onExpand: () => void
  userInitial?: string
}

export const SidebarRail: FC<SidebarRailProps> = ({ onExpand, userInitial }) => (
  <div className="flex flex-col h-full w-12 flex-shrink-0 bg-surface/50 border-r border-border/50 items-center py-3 gap-3">
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={onExpand}
          aria-label="Show sidebar"
          className={cn(
            "h-9 w-9 rounded-xl",
            "bg-surface-elevated/90 backdrop-blur-sm",
            "border border-border/50 hover:border-primary/30",
            "flex items-center justify-center",
            "hover:bg-surface-elevated hover:shadow-glow-sm",
            "transition-all duration-300"
          )}
        >
          <PanelLeftOpen className="h-4 w-4 text-muted-foreground" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="right">
        <p className="text-xs">Show sidebar (Ctrl+B)</p>
      </TooltipContent>
    </Tooltip>

    <div className="flex-1" />

    {userInitial && (
      <div className="h-8 w-8 rounded-full bg-muted flex items-center justify-center text-xs font-medium text-muted-foreground">
        {userInitial}
      </div>
    )}
  </div>
)
